import type { ChangelogData } from "./changelogTypes";

export const changelog: ChangelogData = {
  versions: [
    {
      version: "v48.0.0",
      date: "2026-09-18",
      entries: [
        {
          id: "e9aa259",
          category: "feature",
          title: "Swivu Updates",
          description:
            "Open Updates from the bell in the header or on My Swivu to see alerts and in-progress work in one place. Start from a summary of what needs attention, browse notable items or the full list with search and filters, mark everything read, and ask Sol about what’s going on. Top-of-page alert banners are gone—new activity lives in Updates instead.",
        },
      ],
    },
  ],
};
